import script from "./BouncingModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BouncingModal.vue?vue&type=script&setup=true&lang=js"

import "./BouncingModal.vue?vue&type=style&index=0&id=19f279e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19f279e2"]])

export default __exports__